<template>
  <div>
    <picture class="disBl">
      <source
        media="(max-width:639px)"
        :srcset="src"
        @load="$emit('load:image')"
      >
      <source
        media="(min-width:640px)"
        :srcset="src"
        @load="$emit('load:image')"
      >
      <img
        style="max-width:100%"
        :src="src"
        :alt="alt"
        @load="$emit('load:image')"
      >
    </picture>
    <div class="hidden" v-html="description"></div>
  </div>
</template>

<script>
export default {
  name: 'SurveyPicture',
  props: {
    src: {
      type: String,
      required: true
    },
    alt: {
      type: String,
      required: true
    },
    description: {
      type: String,
      default: ''
    }
  },
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/survey/components/SurveyPicture.vue